import React from 'react';
import { Link } from 'react-router-dom';

function ErrorLoadData(props) {
    return (
        <div className="center-text">
            Ошибка загрузки данных. Попробуйте позже.
            <br />
            <Link
                to="/"
                className="next-button"
                style={{ margin: "1rem auto", display: "block" }}>
                Вернуться на главную
            </Link>
        </div>
    );
}

export default ErrorLoadData;